var md = new MobileDetect(window.navigator.userAgent)

//console.log(md)
console.log(md.is('iPhone'))

if (md.is('iPhone')) {
  var videos = document.getElementsByTagName('video')

  for (i = 0; i < videos.length; i++) {
    var video = videos[i]

    if (video.className.indexOf('video-js') > -1) {
      const player = videojs(video, {
        autoplay: true,
        controls: true,
      })
    }
  }
}
